import Raven from '@Raven'
import { Country } from '@Configs/Country'

const { REACT_APP_ENV, NODE_ENV } = process.env
const USE_STAGE = REACT_APP_ENV || NODE_ENV
const memberCalls2Endpoints = {
    development: 'https://member-calls2-dev.unicity.com',
    production: 'https://member-calls2.unicity.com'
}
//USE_STAGE
const memberCalls2Url = memberCalls2Endpoints['production']

export const ALLOW_OPTIONS = {
    SHOP: 'shop',
    UNIPOWER: 'unipower',
    UNROLL: 'enroll',
    CS: 'cs',
    AS: 'as'
}

export const getProductSource = (isHydra, priceLevel, warehouse) => {
    const url = 'https://member-calls.unicity.com/api/unishop/v1/global/getproducts'
    const params = {
        country_code: Country.getCode3()
    }

    if (warehouse) {
        params.warehouse = warehouse
    }

    if (isHydra === false) {
        params.secret = 'yes'
        params.price_level = priceLevel
    }

    return Raven.get(url, params)
}

export const getProductSourceV2 = ({ status, allow, warehouse, baId }) => {
    const country_code = Country.getCode3()
    const url = `${memberCalls2Url}/products-v2/publish/${country_code}`
    const params = {
        allow,
        status,
        warehouse,
        ...(baId ? { baId } : {})
    }

    return Raven.get(url, params)
}

const mappingWarehouseText = ({ country_code, warehouse_name }) => {
    const MAP_WAHOUSE_TEXTS = {
        IDN: {
            Main: 'Jakarta'
        }
    }
    return MAP_WAHOUSE_TEXTS[country_code] && MAP_WAHOUSE_TEXTS[country_code][warehouse_name] ? MAP_WAHOUSE_TEXTS[country_code][warehouse_name] : warehouse_name
}

export const getWarehousesItems = async () => {
    const country_code = Country.getCode3()
    const url = `${memberCalls2Url}/products-v2/warehouse`
    const params = { country_code }
    const { items = [] } = await Raven.get(url, params)
    const warehouseItems = items.map(({ warehouse_name }) => ({
        value: warehouse_name,
        text: mappingWarehouseText({ country_code, warehouse_name }).toLocaleUpperCase()
    }))
    if (country_code === 'IDN') return warehouseItems.filter(item => item.text !== 'JAKARTA')
    return warehouseItems
}

export const getRemoteWarehouseSelected = ({ warehouseKey }) => {
    const url = `${memberCalls2Url}/remoteStorage/data/${warehouseKey}`
    return Raven.get(url)
}

export const setRemoteWarehouseSelected = ({ warehouseKey, value }) => {
    const url = `${memberCalls2Url}/remoteStorage/data/${warehouseKey}`
    const body = { value }
    return Raven.post(url, body)
}
